// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCpcC5GhUx-Yv0eK3r89U6xECpdQdf3g9U",
  authDomain: "godai-studios.firebaseapp.com",
  projectId: "godai-studios",
  storageBucket: "godai-studios.appspot.com",
  messagingSenderId: "333807505275",
  appId: "1:333807505275:web:e98568c516c2617496f7de",
  measurementId: "G-MPZ7WLK8H4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics }; 